<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [style]="{ width: '60vw' }"
  [contentStyle]="{ height: '70vh', overflow: 'auto' }"
  (onHide)="onCancel()"
  [blockScroll]="true"
>
  <!-- HEADER -->
  <ng-template pTemplate="header">
    <div class="flex flex-col gap-2 w-full">
      <div class="flex items-center gap-2">
        <h3 class="m-0">
          {{ 'animalDuplicate.header.title' | transloco }}
        </h3>
      </div>

      @if (items.length > 1 && (!foundProcessMode || phase === 'edit')) {
      <p-steps
        [model]="stepsItems"
        [activeIndex]="activeStepIndex"
        (activeIndexChange)="onStepChange($event)"
        [readonly]="false"
        styleClass="w-full"
      ></p-steps>
      }
    </div>
  </ng-template>

  <!-- CONTENT -->
  <ng-template pTemplate="content">
    <div class="p-3">
      @if (!foundProcessMode || phase === 'edit') {
      <p>
        {{ 'animalDuplicate.step2.intro' | transloco }}
      </p>

      @if (items.length === 0) {
      <div class="text-sm text-gray-500">
        {{ 'animalDuplicate.noItems' | transloco }}
      </div>
      } @else { @let i = activeStepIndex; @let item = items[i]; @if (item) {
      <div class="p-3 border-round surface-card shadow-1">
        <p-accordion [multiple]="false" [value]="'0'" class="gap-2">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <span>
                {{ 'animalAdd.general.basicData.headline' | transloco }}
              </span>
            </p-accordion-header>

            <p-accordion-content>
              <div class="grid grid-cols-2 gap-2">
                <!-- Rasse -->
                <div class="col-span-2">
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'breed_' + i"
                      [attr.name]="'breed_' + i"
                      [ngClass]="!item.animal.breed ? '!border-red-500' : null"
                      [(ngModel)]="item.animal.breed"
                    />
                    <label [for]="'breed_' + i">
                      {{ 'animalDuplicate.field.breed' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- Name -->
                <div>
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'name_' + i"
                      [attr.name]="'name_' + i"
                      [(ngModel)]="item.animal.name"
                      (ngModelChange)="onNameChanged(i, $event)"
                    />
                    <label [for]="'name_' + i">
                      {{ 'animalDuplicate.field.name' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- Früherer Name -->
                <div>
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'nameOld_' + i"
                      [attr.name]="'nameOld_' + i"
                      [(ngModel)]="item.animal.nameOld"
                    />
                    <label [for]="'nameOld_' + i">
                      {{ 'animalDuplicate.field.previousName' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- Sex -->
                <div>
                  <label class="field-title">
                    {{ 'animalAdd.general.basicData.sex' | transloco }}
                  </label>
                  <div
                    class="flex flex-wrap flex-row"
                    [class.invalid-radio]="!item.animal.sex"
                  >
                    <div class="field-checkbox m-2">
                      <p-radioButton
                        [inputId]="'sex_male_' + i"
                        [name]="'sex_' + i"
                        [value]="'male'"
                        [(ngModel)]="item.animal.sex"
                      ></p-radioButton>
                      <label [for]="'sex_male_' + i" class="ml-2">
                        {{ 'male' | transloco }}
                      </label>
                    </div>
                    <div class="field-checkbox m-2">
                      <p-radioButton
                        [inputId]="'sex_female_' + i"
                        [name]="'sex_' + i"
                        [value]="'female'"
                        [(ngModel)]="item.animal.sex"
                      ></p-radioButton>
                      <label [for]="'sex_female_' + i" class="ml-2">
                        {{ 'female' | transloco }}
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Mutter -->
                <div class="col-span-2">
                  <app-mother-select
                    [mother]="item.animal.mother"
                    [excludeAnimalId]="animal.id"
                    (motherSelected)="onMotherSelected(i, $event)"
                  ></app-mother-select>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>

          <p-accordion-panel value="1">
            <p-accordion-header>
              <span>
                {{ 'animalAdd.general.specifications.headline' | transloco }}
              </span>
            </p-accordion-header>

            <p-accordion-content>
              <div class="grid grid-cols-2 gap-2">
                <!-- Geburtstag -->
                <div>
                  <app-custom-date-picker
                    [label]="'animalEdit.general.specifications.birthday'"
                    [isApproximateYearInput]="true"
                    [isApproximate]="item.animal.birthApprox || false"
                    [isYearOnly]="item.animal.birthdayType || false"
                    [rawInput]="item.animal.birthday || item.animal.birthYear"
                    (valueChange)="onBirthdayChanged(i, $event)"
                    (approxChanged)="onBirthdayApproxChanged(i, $event)"
                    (yearOnlyChanged)="onBirthdayYearOnlyChanged(i, $event)"
                  ></app-custom-date-picker>
                </div>

                <!-- Geburtsort -->
                <div class="mt-10">
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'birthPlace_' + i"
                      [attr.name]="'birthPlace_' + i"
                      [(ngModel)]="item.animal.birthPlace"
                    />
                    <label [for]="'birthPlace_' + i">
                      {{ 'animalDuplicate.field.birthPlace' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- Felltyp -->
                <div>
                  <p-inputgroup>
                    <p-iftalabel>
                      <label for="coatType">
                        {{
                          'animalEdit.general.specifications.coatType'
                            | transloco
                        }}
                      </label>
                      <p-multiSelect
                        id="coatType"
                        [options]="coatTypeOptions"
                        optionLabel="name"
                        optionValue="value"
                        [(ngModel)]="item.animal.coatType"
                        [style]="{ width: '100%' }"
                        [panelStyle]="{ width: '100%' }"
                        appendTo="body"
                      />
                    </p-iftalabel>
                  </p-inputgroup>
                </div>

                <!-- Fellfarbe -->
                <div>
                  <p-inputgroup>
                    <p-iftalabel>
                      <label for="coatColor">
                        {{
                          'animalEdit.general.specifications.coatColor'
                            | transloco
                        }}
                      </label>
                      <input
                        type="text"
                        pInputText
                        id="coatColor"
                        [(ngModel)]="item.animal.coatColor"
                      />
                    </p-iftalabel>
                  </p-inputgroup>
                </div>

                <!-- Abzeichen -->
                <div>
                  <p-inputgroup>
                    <p-iftalabel>
                      <label for="badge">
                        {{
                          'animalEdit.general.specifications.badge' | transloco
                        }}
                      </label>
                      <input
                        type="text"
                        pInputText
                        id="badge"
                        [(ngModel)]="item.animal.badge"
                      />
                    </p-iftalabel>
                  </p-inputgroup>
                </div>

                <!-- Besondere Merkmale -->
                <div>
                  <p-inputgroup>
                    <p-iftalabel>
                      <label for="specialNotice">
                        {{
                          'animalEdit.general.specifications.specialNotice'
                            | transloco
                        }}
                      </label>
                      <input
                        type="text"
                        pInputText
                        id="specialNotice"
                        [(ngModel)]="item.animal.specialNotice"
                      />
                    </p-iftalabel>
                  </p-inputgroup>
                </div>

                <!-- Gewicht -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext p-inputtext-sm w-full"
                        [id]="'weight_' + i"
                        [attr.name]="'weight_' + i"
                        (input)="onWeightInput(i, $event)"
                        [placeholder]="
                          'animalDuplicate.placeholder.weightExample'
                            | transloco
                        "
                        autocomplete="off"
                      />
                      <p-inputgroup-addon>kg</p-inputgroup-addon>
                    </p-inputgroup>
                    <label class="field-title" [for]="'weight_' + i">
                      {{ 'animalDuplicate.field.weight' | transloco }}
                    </label>
                    @if (weightInputInvalid[i]) {
                    <small class="p-error">
                      {{
                        'animalDuplicate.validation.weightFormat' | transloco
                      }}
                    </small>
                    }
                  </p-iftalabel>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>

          <p-accordion-panel value="2">
            <p-accordion-header>
              <span class="items-center">
                {{ 'animalAdd.general.numbers.headline' | transloco }}
              </span>
            </p-accordion-header>

            <p-accordion-content>
              <div class="grid grid-cols-2 gap-2">

                <!-- Alte Buchnummern -->
                <div>
                  <label class="field-title">
                    {{ 'animalDuplicate.field.oldBookNumbers' | transloco }}
                  </label>
                  <p-button
                    icon="pi pi-plus"
                    class="p-button-text p-button-sm"
                    [text]="true"
                    (click)="addOldBookNumber(i)"
                  ></p-button>
                  <div class="flex flex-col">
                    @for (_b of item.animal.oldBookNumberList; track
                    trackByIndex(j, _b); let j = $index) {
                    <div class="mb-1 flex items-center">
                      <p-inputgroup>
                        <input
                          type="text"
                          class="p-inputtext rounded-r-none!"
                          style="padding: 14px"
                          [id]="'oldBookNumber_' + i + '_' + j"
                          [attr.name]="'oldBookNumber_' + i + '_' + j"
                          [(ngModel)]="item.animal.oldBookNumberList[j]"
                        />
                      </p-inputgroup>
                      <p-button
                        icon="pi pi-trash"
                        styleClass="ml-2 p-button-sm"
                        [rounded]="true"
                        severity="danger"
                        (click)="removeOldBookNumber(i, j)"
                      ></p-button>
                    </div>
                    }
                  </div>
                </div>

                <!-- Transponder -->
                <div>
                  <label class="field-title">
                    {{ 'animalDuplicate.field.transponderNumbers' | transloco }}
                  </label>
                  <p-button
                    icon="pi pi-plus"
                    class="p-button-text p-button-sm"
                    [text]="true"
                    (click)="addTransponderNumber(i)"
                  ></p-button>

                  <div class="flex flex-col">
                    @for (_t of item.animal.transponderNumber; track
                    trackByIndex(j, _t); let j = $index) {
                    <div class="mb-1 flex items-center">
                      <p-inputgroup>
                        <input
                          type="text"
                          class="p-inputtext rounded-r-none!"
                          [id]="'transponderNumber_' + i + '_' + j"
                          [attr.name]="'transponderNumber_' + i + '_' + j"
                          [(ngModel)]="item.animal.transponderNumber[j]"
                        />
                        <app-barcode-scanner
                          [bindTo]="'transponderNumber_' + i + '_' + j"
                        ></app-barcode-scanner>
                      </p-inputgroup>

                      <p-button
                        icon="pi pi-trash"
                        styleClass="ml-2 p-button-sm"
                        [rounded]="true"
                        severity="danger"
                        (click)="removeTransponderNumber(i, j)"
                      ></p-button>
                    </div>
                    }
                  </div>
                </div>


                <!-- lifeNumber -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'lifeNumber_' + i"
                        [attr.name]="'lifeNumber_' + i"
                        [(ngModel)]="item.animal.lifeNumber"
                      />
                      <app-barcode-scanner
                        [bindTo]="'lifeNumber_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label class="field-title" [for]="'lifeNumber_' + i">
                      {{ 'animalAdd.general.numbers.lifeNumber' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- petPassportNumber -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'petPassportNumber_' + i"
                        [attr.name]="'petPassportNumber_' + i"
                        [(ngModel)]="item.animal.petPassportNumber"
                      />
                      <app-barcode-scanner
                        [bindTo]="'petPassportNumber_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label class="field-title" [for]="'petPassportNumber_' + i">
                      {{
                        'animalAdd.general.numbers.petPassportNumber'
                          | transloco
                      }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- equinePassportNumber -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'equinePassportNumber_' + i"
                        [attr.name]="'equinePassportNumber_' + i"
                        [(ngModel)]="item.animal.equinePassportNumber"
                      />
                      <app-barcode-scanner
                        [bindTo]="'equinePassportNumber_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label
                      class="field-title"
                      [for]="'equinePassportNumber_' + i"
                    >
                      {{
                        'animalAdd.general.numbers.equinePassportNumber'
                          | transloco
                      }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- ringNumber -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'ringNumber_' + i"
                        [attr.name]="'ringNumber_' + i"
                        [(ngModel)]="item.animal.ringNumber"
                      />
                      <app-barcode-scanner
                        [bindTo]="'ringNumber_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label class="field-title" [for]="'ringNumber_' + i">
                      {{ 'animalAdd.general.numbers.ringNumber' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- earTag -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'earTag_' + i"
                        [attr.name]="'earTag_' + i"
                        [(ngModel)]="item.animal.earTag"
                      />
                      <app-barcode-scanner
                        [bindTo]="'earTag_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label class="field-title" [for]="'earTag_' + i">
                      {{ 'animalAdd.general.numbers.earTagNumber' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- tattoo -->
                <div>
                  <p-iftalabel>
                    <p-inputgroup>
                      <input
                        type="text"
                        class="p-inputtext rounded-r-none!"
                        [id]="'tattoo_' + i"
                        [attr.name]="'tattoo_' + i"
                        [(ngModel)]="item.animal.tattoo"
                      />
                      <app-barcode-scanner
                        [bindTo]="'tattoo_' + i"
                      ></app-barcode-scanner>
                    </p-inputgroup>
                    <label class="field-title" [for]="'tattoo_' + i">
                      {{ 'animalAdd.general.numbers.tattoo' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <!-- tattooLocation -->
                <div>
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'tattooLocation_' + i"
                      [attr.name]="'tattooLocation_' + i"
                      [(ngModel)]="item.animal.tattooLocation"
                    />
                    <label class="field-title" [for]="'tattooLocation_' + i">
                      {{
                        'animalAdd.general.numbers.tattooLocation' | transloco
                      }}
                    </label>
                  </p-iftalabel>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>

          <p-accordion-panel value="3">
            <p-accordion-header>
              <span class="items-center">
                {{ 'animalEdit.general.headlineOrigin' | transloco }}
              </span>
            </p-accordion-header>

            <p-accordion-content>
              <div class="grid grid-cols-2 gap-2">
                @if (!foundProcessMode) {
                <div>
                  <app-custom-date-picker
                    [label]="'animalDuplicate.field.entryDate'"
                    [rawInput]="item.origin.dateOfReceipt"
                    (valueChange)="onOriginDateChanged(i, $event)"
                    [required]="true"
                    [inputValid]="!!item.origin.dateOfReceipt"
                  ></app-custom-date-picker>
                </div>
                }

                <div>
                  <p-iftalabel>
                    <input
                      type="text"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'originLocation_' + i"
                      [attr.name]="'originLocation_' + i"
                      [(ngModel)]="item.origin.location"
                    />
                    <label [for]="'originLocation_' + i">
                      {{ 'animalDuplicate.field.originLocation' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>

                <div>
                  <p-iftalabel>
                    <textarea
                      rows="4"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'originSpecialInformation_' + i"
                      [attr.name]="'originSpecialInformation_' + i"
                      [(ngModel)]="item.origin.specialInformation"
                    ></textarea>
                    <label [for]="'originSpecialInformation_' + i">
                      {{
                        'animalDuplicate.field.specialInformation' | transloco
                      }}
                    </label>
                  </p-iftalabel>
                </div>

                <div>
                  <p-iftalabel>
                    <textarea
                      rows="4"
                      class="p-inputtext p-inputtext-sm w-full"
                      [id]="'originOtherComments_' + i"
                      [attr.name]="'originOtherComments_' + i"
                      [(ngModel)]="item.origin.otherComments"
                    ></textarea>
                    <label [for]="'originOtherComments_' + i">
                      {{ 'animalDuplicate.field.otherComments' | transloco }}
                    </label>
                  </p-iftalabel>
                </div>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
          @if (item.bcs) {
            <p-accordion-panel value="4">
              <p-accordion-header>
                <span class="items-center">
                  {{ 'bcs.sectionTitle' | transloco }}
                  @if (isBcsInvalid(item)) {
                    <span
                      class="pi pi-exclamation-triangle text-red-400"
                      [pTooltip]="'animalAdd.general.invalidTooltip' | transloco"
                      tooltipPosition="right"
                    ></span>
                  }
                </span>
              </p-accordion-header>
              <p-accordion-content>
                <app-body-condition-score
                  [careCtrl]="item.bcs.careCtrl"
                  [nutritionCtrl]="item.bcs.nutritionCtrl"
                  [temperamentCtrl]="item.bcs.temperamentCtrl"
                ></app-body-condition-score>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>
      } }
      }

      <!-- PDF-Phase: eine Vorschau pro Duplikat -->
      @if (isFoundPdfPhase) {
        <p-accordion [multiple]="false" [value]="'0'" class="gap-2">
          @for (it of previewItems; track trackByIndex(idx, it); let idx = $index) {
            <p-accordion-panel [value]="idx.toString()">
              <p-accordion-header>
                <span>{{ previewLabel(idx) }}</span>
              </p-accordion-header>
              <p-accordion-content>
                @if (previewBlobs[idx]) {
                  <app-pdf-viewer
                    [pdf]="previewBlobs[idx]!"
                    mode="preview"
                    height="calc(70vh - 120px)"
                  ></app-pdf-viewer>
                } @else {
                  <div class="p-3 text-red-500">
                    {{ 'animalAdd.toast.pdfPreviewError' | transloco }}
                  </div>
                }
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      }

      <!-- Unterschriften-Phase: eine gemeinsame Signatur für alle Duplikate -->
      @if (isFoundSignaturePhase) {
        <div class="grid grid-cols-12 gap-4 p-2">
          <div class="col-span-12 md:col-span-6">
            <h4 class="mb-2">
              {{ 'animalAdd.general.foundAnimal.signature.finder' | transloco }}
            </h4>
            <app-signature-pad
              [value]="sharedSignature.finderSignature"
              (signatureSaved)="sharedSignature.finderSignature = $event"
              (signatureCleared)="sharedSignature.finderSignature = null"
            ></app-signature-pad>
          </div>

          <div class="col-span-12 md:col-span-6">
            <h4 class="mb-2">
              {{ 'animalAdd.general.foundAnimal.signature.employee' | transloco }}
            </h4>
            <app-signature-pad
              [value]="sharedSignature.employeeSignature"
              (signatureSaved)="sharedSignature.employeeSignature = $event"
              (signatureCleared)="sharedSignature.employeeSignature = null"
            ></app-signature-pad>
          </div>

          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <input
                pInputText
                class="w-full"
                [(ngModel)]="sharedSignature.signatureLocation"
              />
              <label>
                {{ 'animalAdd.general.foundAnimal.signature.location' | transloco }}
              </label>
            </p-iftalabel>
          </div>

          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-datepicker
                [(ngModel)]="sharedSignature.signatureDate"
                [showIcon]="true"
                [iconDisplay]="'input'"
                dateFormat="dd.mm.yy"
              />
              <label>
                {{ 'animalAdd.general.foundAnimal.signature.date' | transloco }}
              </label>
            </p-iftalabel>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
  @if (!foundProcessMode) {
  <div class="flex justify-between items-center w-full">
    <!-- Links: Navigation -->
     @if (items.length > 1) {
    <div class="flex gap-2">
      <button
        type="button"
        class="p-button p-button p-button-sm"
        (click)="onPrevStep()"
        [disabled]="activeStepIndex <= 0 || items.length === 0"
        [class.p-button-secondary]="activeStepIndex <= 0 || items.length === 0"
      >
        {{ 'animalDuplicate.button.back' | transloco }}
      </button>

      <button
        type="button"
        class="p-button p-button p-button-sm"
        (click)="onNextStep()"
        [disabled]="activeStepIndex >= items.length - 1 || items.length === 0"
        [class.p-button-secondary]="activeStepIndex >= items.length - 1 || items.length === 0"
      >
        {{ 'animalDuplicate.button.next' | transloco }}
      </button>
      <button
        type="button"
        class="p-button p-button-danger p-button-sm"
        (click)="onDeleteCurrentDuplicate()"
        [disabled]="items.length === 0"
      >
        <i class="pi pi-trash mr-1"></i>
        {{ 'animalDuplicate.button.deleteThisDuplicate' | transloco }}
      </button>
    </div>
  } @else {
    <div></div>
  }

    <!-- Rechts: Cancel / Add / Create -->
    <div class="flex gap-2">
      <p-button
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
        (click)="onCancel()"
      >
      </p-button>

      <button
        type="button"
        class="p-button p-button-sm"
        (click)="onAddDuplicate()"
      >
        <i class="pi pi-plus mr-1"></i>
        {{ 'animalDuplicate.button.addDuplicate' | transloco }}
      </button>

      <button
        type="button"
        class="p-button p-button-sm"
        (click)="onSubmit()"
        [disabled]="items.length === 0"
      >
        {{ 'animalDuplicate.button.create' | transloco }}
      </button>
    </div>
  </div>
  } @else {
  <!-- Fundtierprozess-Footer (phasenabhängig) -->
  <div class="flex justify-between items-center w-full">
    <!-- Links: Navigation -->
    <div class="flex gap-2">
      @if (phase === 'edit' && items.length > 1) {
        <button
          type="button"
          class="p-button p-button p-button-sm"
          (click)="onPrevStep()"
          [disabled]="activeStepIndex <= 0"
          [class.p-button-secondary]="activeStepIndex <= 0"
        >
          {{ 'animalDuplicate.button.back' | transloco }}
        </button>
        <button
          type="button"
          class="p-button p-button p-button-sm"
          (click)="onNextStep()"
          [disabled]="activeStepIndex >= items.length - 1"
          [class.p-button-secondary]="activeStepIndex >= items.length - 1"
        >
          {{ 'animalDuplicate.button.next' | transloco }}
        </button>
        <button
          type="button"
          class="p-button p-button-danger p-button-sm"
          (click)="onDeleteCurrentDuplicate()"
        >
          <i class="pi pi-trash mr-1"></i>
          {{ 'animalDuplicate.button.deleteThisDuplicate' | transloco }}
        </button>
      }
      @if (phase !== 'edit') {
        <p-button
          [text]="true"
          icon="pi pi-angle-left"
          label="{{ 'animalDuplicate.button.back' | transloco }}"
          (click)="onPhaseBack()"
        />
      }
    </div>

    <!-- Rechts: Cancel / Add / Weiter / Speichern -->
    <div class="flex gap-2">
      <p-button
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
        (click)="onCancel()"
      />

      @if (phase === 'edit') {
        <button
          type="button"
          class="p-button p-button-sm"
          (click)="onAddDuplicate()"
        >
          <i class="pi pi-plus mr-1"></i>
          {{ 'animalDuplicate.button.addDuplicate' | transloco }}
        </button>
      }

      @if (phase === 'edit' || phase === 'pdf') {
        <p-button
          iconPos="right"
          icon="pi pi-angle-right"
          label="{{ 'animalAdd.nextStep' | transloco }}"
          (click)="onPhaseNext()"
          [loading]="isGeneratingPreviews"
          [disabled]="isGeneratingPreviews || (phase === 'edit' && !allItemsValidForPdf())"
        />
      }

      @if (phase === 'signatures') {
        <p-button
          icon="pi pi-save"
          label="{{ 'modal.save' | transloco }}"
          (click)="onSubmit()"
          [disabled]="!isSignatureComplete()"
        />
        <p-button
          icon="pi pi-send"
          label="Speichern & PDF senden"
          (click)="onSubmitAndSend()"
          [disabled]="!isSignatureComplete()"
        />
      }
    </div>
  </div>
  }
</ng-template>
</p-dialog>

<p-confirmDialog appendTo="body"></p-confirmDialog>

@if (bundleSendVisible) {
  <app-send-found-report-bundle-dialog
    [items]="bundleItems"
    [availableContacts]="foundShared?.authorityContacts ?? []"
    [authorityInformation]="origin?.authorityInformation ?? null"
    [visible]="bundleSendVisible"
    (visibleChange)="onBundleVisibleChange($event)"
  ></app-send-found-report-bundle-dialog>
}
